try {
    window.Popper = require('popper.js').default;
    require('bootstrap');
} catch (e) { }

import slick from 'slick-carousel';
import bootstrapSelect from 'bootstrap-select';
import shares from './plugins/jquery.shares';
import lightgallery from 'lightgallery';

window.form = require("./plugins/jquery.form");
window.Swal = require("sweetalert2");
window.validation = require("jquery-validation");
window.rut = require("./plugins/jquery.rut");
window.letters = require("./plugins/jquery.letters");
window.numbers = require("./plugins/jquery.numbers");
window.mask = require("./plugins/jquery.mask");
window.formulator = require("./plugins/jquery.formulator");